import React, { useState } from "react";
import "../Home/Home.css";
import Modal from "react-modal";
import Swal from "sweetalert2";

import { FaRegCirclePlay, FaCarOn } from "react-icons/fa6";
import { MdSupportAgent } from "react-icons/md";
import { GiReceiveMoney } from "react-icons/gi";
import emailjs from "emailjs-com";

const Home = () => {

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [enquiryModalIsOpen, setEnquiryModalIsOpen] = useState(false);
  const [brochureModalIsOpen, setBrochureModalIsOpen] = useState(false);
  const [detailsModalIsOpen, setDetailsModalIsOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const apartmentOptions = [
    "3 BHK 1390 sq. ft.",
    "3 BHK 1690 sq. ft.",
    "3 BHK 1925 sq. ft.",
    "4 BHK 2150 sq. ft.",
    "4 BHK 2550 sq. ft."
  ];

  const openModal = (image) => {
    setSelectedImage(image);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setSelectedImage(null);
  };

  const openEnquiryModal = () => {
    setEnquiryModalIsOpen(true);
  };

  const closeEnquiryModal = () => {
    setEnquiryModalIsOpen(false);
  };

  const openBrochureModal = () => {
    setBrochureModalIsOpen(true);
  };

  const closeBrochureModal = () => {
    setBrochureModalIsOpen(false);
  };

  const openDetailsModal = () => {
    setDetailsModalIsOpen(true);
  };

  const closeDetailsModal = () => {
    setDetailsModalIsOpen(false);
  };

  const validateName = (value) => {
    if (!/^[a-zA-Z\s]*$/.test(value)) {
      setNameError("Name can only contain alphabets");
    } else {
      setNameError("");
    }
    setName(value);
  };

  const validateEmail = (value) => {
    if (!/\S+@\S+\.\S+/.test(value)) {
      setEmailError("Please enter a valid email address");
    } else {
      setEmailError("");
    }
    setEmail(value);
  };

  const validateMobile = (value) => {
    if (!/^\d{10}$/.test(value)) {
      setMobileError("Mobile number must be 10 digits");
    } else {
      setMobileError("");
    }
    setMobile(value);
  };

 const handleSubmit = (e) => {
  e.preventDefault();
  if (!nameError && !emailError && !mobileError) {
    setIsSubmitting(true);

    const templateParams = {
      name,
      email,
      mobile,
      option: selectedOption,
      bind_message: "Irish Platinum"
    };

    emailjs
      .send(
        "service_mshzku3",
        "template_lktgcfv",
        templateParams,
        "hzdloJVjIk6jCAoRL"
      )
      .then((response) => {
        Swal.fire({
          title: "Form Submitted Successfully!",
          text: "Thanks you for expressing interest on our website our expert will get in touch with you shortly",
          imageUrl: "ty2.jpg",
          imageWidth: 400,
          imageHeight: 200,
          imageAlt: "Custom image",
        });
        setIsSubmitting(false);
        closeEnquiryModal();
        closeBrochureModal();
        closeDetailsModal();
      })
      .catch((error) => {
        Swal.fire({
          title: "Oops!",
          text: "There was an error submitting the form. Please try again.",
          icon: "error"
        });
        setIsSubmitting(false);
      });
  } else {
    alert("Please fix the errors in the form");
  }
};

  const images = ["g1.webp", "g2.webp", "i11.webp", "g4.webp", "g5.webp", "g6.webp"];

  return (
    <>

 


      <section id="home" className="slider-section">
        <div
          id="carouselExampleIndicators2"
          className="carousel slide"
          data-bs-ride="carousel"
          data-bs-interval="2000"
        >
          <div className="carousel-indicators">
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators2"
              data-bs-slide-to={0}
              className="active"
              aria-current="true"
              aria-label="Slide 1"
            />
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators2"
              data-bs-slide-to={1}
              aria-label="Slide 2"
            />
          </div>
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img src="i11.webp" loading="lazy" className="image-slider" alt="luxury-apartments-in-noida-extension" />
            </div>
            <div className="carousel-item">
              <img src="i2.webp" loading="lazy" className="image-slider" alt="premium-flats-in-noida" />
            </div>
          </div>
          <button
            className="carousel-control-prev1"
            type="button"
            data-bs-target="#carouselExampleIndicators2"
            data-bs-slide="prev"
          >
            <span className="carousel-control-prev-icon" aria-hidden="true" />
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next2"
            type="button"
            data-bs-target="#carouselExampleIndicators2"
            data-bs-slide="next"
          >
            <span className="carousel-control-next-icon" aria-hidden="true" />
            <span className="visually-hidden">Next</span>
          </button>
          <div className="carousel-overlay">
         
            <h2>Irish <br/> Platinum</h2>
            <p>At Sector 10, Greater Noida West</p>
            <p className="group-p">By Irish Group</p>
            <div className="offer-list">
              <div className="offer-div">
                
                <ul>
                  <li>✓ Land Area : 5 Acres </li>
                  <li>✓ Total Towers : 4</li>
                  <li>✓ No. of Units: 570</li>
                  <li>✓ Total Floors : G+29</li>
                  <li>✓ All Weather Swimming Pool</li>
                  <li>✓ 4 - 6 High-Speed Elevators</li>
                </ul>
              </div>
            </div>
            <p className="price-info">
              Premium 3 & 4 BHK Apartments
              <br />
              Starting Price - On Request*
            </p>
            <button className="button-13" onClick={openEnquiryModal}>
              Enquire Now
            </button>
          </div>
        </div>
      </section>

      <Modal
        isOpen={enquiryModalIsOpen}
        onRequestClose={closeEnquiryModal}
        contentLabel="Enquiry Modal"
        className="modal-main2"
      >
        <button className="close-button2" onClick={closeEnquiryModal}>
          ×
        </button>
        <div className="modal-full">
          <div className="modalleft">
            <h4 className="modal-heading">We Promise</h4>
            <div className="modal-logo-left">
              <MdSupportAgent className="modal-logo1" />
              <p className="modal-sub-heading">Instant Call Back </p>
            </div>
            <div className="modal-logo-left">
              <FaCarOn className="modal-logo1" />
              <p className="modal-sub-heading">Free Site Visit</p>
            </div>
            <div className="modal-logo-left">
              <GiReceiveMoney className="modal-logo1" />
              <p className="modal-sub-heading">Unmatched Price</p>
            </div>
          </div>
          <div className="modalright">
            <h2 className="modal-heading">IRISH PLATINUM</h2>
            <p className="modal-sub-heading">
              At Sector 10, Greater Noida West
            </p>
            <form className="modal-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Name:</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={name}
                  onChange={(e) => validateName(e.target.value)}
                  required
                />
                {nameError && <p className="error">{nameError}</p>}
              </div>
              <div className="form-group">
                <label htmlFor="email">Email:</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={email}
                  onChange={(e) => validateEmail(e.target.value)}
                  required
                />
                {emailError && <p className="error">{emailError}</p>}
              </div>
              <div className="form-group">
                <label htmlFor="mobile">Mobile:</label>
                <input
                  type="tel"
                  id="mobile"
                  name="mobile"
                  value={mobile}
                  onChange={(e) => validateMobile(e.target.value)}
                  required
                />
                {mobileError && <p className="error">{mobileError}</p>}
              </div>
              <div className="form-group">
                <label htmlFor="option">Property Type:</label>
                <select
                  id="option"
                  name="option"
                  className="select-input"
                  value={selectedOption}
                  onChange={(e) => setSelectedOption(e.target.value)}
                  required
                >
                  <option value="">Select Property Type</option>
                  {apartmentOptions.map((option, index) => (
                    <option key={index} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>
              <div className="butt-f">
                <button
                  className="submit-button-f"
                  type="submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : "Enquire Now"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>
      <section id="overview" className="overview-section">
        <div className="all-overview">
          <h1 className="head">Summary</h1>
          <div className="container">
            <div className="div-cont">
              <h2 className="section-title">Irish Platinum</h2>
              <p className="location">At Sector 10, Greater Noida West</p>
              <p id="br" className="description">
              Irish Platinum in Sector 10 of Noida Extension is attractive. Noida Extension, also called Greater Noida West, is known for its strategic location and improved infrastructure, making it a popular real estate hub. The mention of ultra-luxury apartments suggests a high-quality lifestyle with top-notch amenities, excellent construction, and a convenient location within Noida Extension. However, thorough research and careful consideration are essential before making any investment decisions.
              </p>

              <div className="overview-button" id="brochure">
                <button className="button-34" onClick={openBrochureModal}>
                  Download Brochure
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="about-overview">
          <div className="containerr">
            <p className="location">About Irish Group</p>
            <p className="description">
            Irish Platinum is situated at Sector 10, Greater Noida West, covering 5 acres with 4 towers and 570 units. It offers luxurious 3 & 4 BHK apartments and includes elegant floor lobbies, fast elevators, and a fully equipped gym. Located in lively Noida Extension, it ensures a lavish lifestyle with amenities such as a swimming pool, kids play area, and 24x7 security, making it perfect for homebuyers seeking comfort and convenience.
            </p>
          </div>
        </div>

{/*-
        <div className="project-highlights">
          <h2>Project Highlights</h2>
          <ul>
            <li>Fully Equipped Gym</li>
            <li>Senior Citizens’ Pavilion</li>
            <li>
            Jogging/Walking Track
            </li>
            <li>CCTV Surveillance</li>
            <li>Swimming Pool</li>
            <li>⁠Badminton Court</li>

            <li>Kids Play Area</li>
            <li>
            Flower Garden
            </li>
            <li>
            Salon/Spa
            </li>
            <li>
            24X7 Security
            </li>
            <li>Multipurpose Hall</li>
            <li>Pharmacy</li>
          </ul>
        </div>
        -*/}
      </section>

      <Modal
        isOpen={brochureModalIsOpen}
        onRequestClose={closeBrochureModal}
        contentLabel="Brochure Modal"
        className="modal-main2"
      >
        <button className="close-button2" onClick={closeBrochureModal}>
          ×
        </button>
        <div className="modal-full">
          <div className="modalleft">
            <h4 className="modal-heading">We Promise</h4>
            <div className="modal-logo-left">
              <MdSupportAgent className="modal-logo1" />
              <p className="modal-sub-heading">Instant Call Back </p>
            </div>
            <div className="modal-logo-left">
              <FaCarOn className="modal-logo1" />
              <p className="modal-sub-heading">Free Site Visit</p>
            </div>
            <div className="modal-logo-left">
              <GiReceiveMoney className="modal-logo1" />
              <p className="modal-sub-heading">Unmatched Price</p>
            </div>
          </div>
          <div className="modalright">
            <h2 className="modal-heading">IRISH PLATINUM</h2>
            <p className="modal-sub-heading">
              At Sector 10, Greater Noida West
            </p>
            <form className="modal-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Name:</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={name}
                  onChange={(e) => validateName(e.target.value)}
                  required
                />
                {nameError && <p className="error">{nameError}</p>}
              </div>
              <div className="form-group">
                <label htmlFor="email">Email:</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={email}
                  onChange={(e) => validateEmail(e.target.value)}
                  required
                />
                {emailError && <p className="error">{emailError}</p>}
              </div>
              <div className="form-group">
                <label htmlFor="mobile">Mobile:</label>
                <input
                  type="tel"
                  id="mobile"
                  name="mobile"
                  value={mobile}
                  onChange={(e) => validateMobile(e.target.value)}
                  required
                />
                {mobileError && <p className="error">{mobileError}</p>}
              </div>
              <div className="form-group">
                <label htmlFor="option">Property Type:</label>
                <select
                  id="option"
                  name="option"
                  className="select-input"
                  value={selectedOption}
                  onChange={(e) => setSelectedOption(e.target.value)}
                  required
                >
                  <option value="">Select Property Type</option>
                  {apartmentOptions.map((option, index) => (
                    <option key={index} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>
              <div className="butt-f">
                <button
                  className="submit-button-f"
                  type="submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : "Click To Download"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>
      <section id="price" className="price-section-main">
        <div className="price-head-div">
          <h1 className="head">Pricing</h1>
        </div>
        <div className="price-section">
          <table>
            <thead>
              <tr>
                <th>Type</th>
                <th>Saleable Area</th>
                <th>Final Price</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {/* Data for 3 BHK */}
              <tr>
                <td>3 BHK </td>
                <td>1390 sq. ft.* </td>
                <td>On Request *</td>
                <td>
                  <button className="button-13" onClick={openDetailsModal}>
                    Get Details
                  </button>
                </td>
              </tr>
              <tr>
                <td>3 BHK </td>
                <td>1690 sq. ft.*</td>
                <td>On Request *</td>
                <td>
                  <button className="button-13" onClick={openDetailsModal}>
                    Get Details
                  </button>
                </td>
              </tr>
              {/* Data for 4 BHK */}
              <tr>
                <td>3 BHK</td>
                <td>1925 sq. ft.*</td>
                <td>On Request*</td>
                <td>
                  <button className="button-13" onClick={openDetailsModal}>
                    Get Details
                  </button>
                </td>
              </tr>
              <tr>
                <td>4 BHK</td>
                <td>2150 sq. ft.* </td>
                <td>On Request*</td>
                <td>
                  <button className="button-13" onClick={openDetailsModal}>
                    Get Details
                  </button>
                </td>
              </tr>
              <tr>
                <td>4 BHK</td>
                <td>2550 sq. ft.*</td>
                <td>On Request*</td>
                <td>
                  <button className="button-13" onClick={openDetailsModal}>
                    Get Details
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        <div className="div-price-image">
  <a 
    href="#price" 
    className="anc" 
    onClick={openEnquiryModal}
  >
    <div className="darksoul-card2">
      <div className="circle2" />
      <img
        src="rupi.png"
        loading="lazy"
        alt="3-bhk-apartments-noida-extension"
        width={49}
        height={60}
        style={{ zIndex: 0 }}
      />
      <p className="content">Know Price</p>
    </div>
  </a>
</div>
        </div>
      </section>
      <Modal
        isOpen={detailsModalIsOpen}
        onRequestClose={closeDetailsModal}
        contentLabel="Details Modal"
        className="modal-main2"
      >
        <button className="close-button2" onClick={closeDetailsModal}>
          ×
        </button>
        <div className="modal-full">
          <div className="modalleft">
            <h4 className="modal-heading">We Promise</h4>
            <div className="modal-logo-left">
              <MdSupportAgent className="modal-logo1" />
              <p className="modal-sub-heading">Instant Call Back </p>
            </div>
            <div className="modal-logo-left">
              <FaCarOn className="modal-logo1" />
              <p className="modal-sub-heading">Free Site Visit</p>
            </div>
            <div className="modal-logo-left">
              <GiReceiveMoney className="modal-logo1" />
              <p className="modal-sub-heading">Unmatched Price</p>
            </div>
          </div>
          <div className="modalright">
            <h2 className="modal-heading">IRISH PLATINUM</h2>
            <p className="modal-sub-heading">
              At Sector 10, Greater Noida West
            </p>
            <form className="modal-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Name:</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={name}
                  onChange={(e) => validateName(e.target.value)}
                  required
                />
                {nameError && <p className="error">{nameError}</p>}
              </div>
              <div className="form-group">
                <label htmlFor="email">Email:</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={email}
                  onChange={(e) => validateEmail(e.target.value)}
                  required
                />
                {emailError && <p className="error">{emailError}</p>}
              </div>
              <div className="form-group">
                <label htmlFor="mobile">Mobile:</label>
                <input
                  type="tel"
                  id="mobile"
                  name="mobile"
                  value={mobile}
                  onChange={(e) => validateMobile(e.target.value)}
                  required
                />
                {mobileError && <p className="error">{mobileError}</p>}
              </div>
              <div className="form-group">
                <label htmlFor="option">Property Type:</label>
                <select
                  id="option"
                  name="option"
                  className="select-input"
                  value={selectedOption}
                  onChange={(e) => setSelectedOption(e.target.value)}
                  required
                >
                  <option value="">Select Property Type</option>
                  {apartmentOptions.map((option, index) => (
                    <option key={index} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>
              <div className="butt-f">
                <button
                  className="submit-button-f"
                  type="submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : "Get Price Details"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>
      <section id="site&floor" className="sfp-section-main">
        <div className="sfp-head-div">
          <h1 className="head">Site Map & Floor Layout</h1>
        </div>
        <div className="site-container">
          <div onClick={openEnquiryModal} className="image-container-s">
            <img src="s1.webp" loading="lazy" alt="4-bhk-apartments-noida" className="image" />
            <div className="overlay">Enquire Now For 3 BHK (1390 sq.ft.)</div>
          </div>
          <div onClick={openEnquiryModal} className="image-container-s">
            <img src="s2.webp" loading="lazy" alt="best-residential-project-in-noida" className="image" />
            <div className="overlay">Enquire Now For 3 BHK (1690 sq.ft.)</div>
          </div>
          <div onClick={openEnquiryModal} className="image-container-s">
            <img src="s3.webp" loading="lazy" alt="ready-to-move-flats-noida-extension" className="image" />
            <div className="overlay">Enquire Now For 3 BHK (1925 sq.ft.)</div>
          </div>
          
        </div>
        <div className="site-container2">
          <div onClick={openEnquiryModal} className="image-container-s">
            <img src="s4.webp" loading="lazy" alt="noida-extension-luxury-homes" className="image" />
            <div className="overlay">Enquire Now For 4 BHK (2150 sq.ft.)</div>
          </div>
          <div onClick={openEnquiryModal} className="image-container-s">
            <img src="s5.webp" loading="lazy" alt="high-rise-apartments-noida" className="image" />
            <div className="overlay">Enquire Now For 4 BHK (2550 sq.ft.)</div>
          </div>
          <div onClick={openEnquiryModal} className="image-container-s">
            <img src="s6.webp" loading="lazy" alt="noida-extension-premium-residences" className="image" />
            <div className="overlay">Enquire Now For Site Plan</div>
          </div>
          
        </div>
      </section>
      <section id="amenities" className="amenities-section-main">
        <div className="amen-head-div">
          <h1 className="head">Facilities</h1>
        </div>
        <div className="amenities-section">
          <div className="amenities-car">
            <div
              id="carouselExampleFade"
              className="carousel slide carousel-fade"
              data-bs-ride="carousel"
            >
              <div className="carousel-inner">
                <div className="carousel-item active">
                  <div className="div-car">
                    <ul>
                      <li>All Weather Swimming Pool</li>
                      <li>All Weather Kids Pool</li>
                      <li>Interactive Fountains with Sit-out Area</li>
                    </ul>
                    <ul>
                      <li>Loungers Under Garden Umbrella</li>
                      <li>11 Feet Ceiling Height</li>
                      <li>⁠Pathway/Jogging Track</li>
                    </ul>
                  </div>
                </div>
                <div className="carousel-item">
                  <div className="div-car">
                    <ul>
                      <li>Skating Rink</li>
                      <li>Gymnasium(Outdoor)</li>
                      <li>⁠Badminton Court(Indoor)</li>
                    </ul>
                    <ul>
                      <li>Squash Court</li>
                      <li>Gym(Indoor)</li>
                      <li>Billiard</li>
                    </ul>
                  </div>
                </div>
                <div className="carousel-item">
                  <div className="div-car">
                    <ul>
                      <li>Club Platinum</li>
                      <li>Kids Play Area</li>
                      <li>⁠Cricket Net Practice</li>
                    </ul>
                    <ul>
                      <li>Basketball Court</li>
                      <li>CCTV Surveillance</li>
                      <li>Ample Parking Area</li>
                    </ul>
                  </div>
                </div>
              </div>
              <button
                className="carousel-control-prev"
                type="button"
                data-bs-target="#carouselExampleFade"
                data-bs-slide="prev"
              >
                <span
                  className="carousel-control-prev-icon"
                  aria-hidden="true"
                />
                <span className="visually-hidden">Previous</span>
              </button>
              <button
                className="carousel-control-next"
                type="button"
                data-bs-target="#carouselExampleFade"
                data-bs-slide="next"
              >
                <span
                  className="carousel-control-next-icon"
                  aria-hidden="true"
                />
                <span className="visually-hidden">Next</span>
              </button>
            </div>
          </div>
        </div>
        <img src="am.JPG" loading="lazy" className="am-img" alt="irish-platinum-sector-10-noida"/>
      </section>
      <section id="gallery" className="gallery-section-main">
        <div className="gal-head-div">
          <h1 className="head">Visual Showcase</h1>
        </div>
        <div className="gallery-section">
          <div className="App1">
            <div className="image-grid">
              {images.map((image, index) => (
                <div key={index} className="image-container">
                  <img
                    src={image}
                    loading="lazy"
                    alt={`img-${index}`}
                    onClick={() => openModal(image)}
                  />
                </div>
              ))}
            </div>

            <Modal
              isOpen={modalIsOpen}
              onRequestClose={closeModal}
              contentLabel="Image Modal"
              className="Modal"
              overlayClassName="Overlay"
            >
              <button className="close-button" onClick={closeModal}>
                ×
              </button>
              {selectedImage && (
                <img className="modal-img" loading="lazy" src={selectedImage} alt="luxury-apartments-sector-10-noida" />
              )}
            </Modal>
          </div>
        </div>
      </section>
      <section id="location" className="location-section">
        <div className="lo-head-div">
          <h1 className="head">Our Location</h1>
        </div>
        <div className="location-main">
          <div className="responsive-map">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3503.890393122129!2d77.47968797549855!3d28.573053875697294!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce5f80700362f%3A0x349f3469e7391a49!2sIrish%20Platinum!5e0!3m2!1sen!2sin!4v1719576115957!5m2!1sen!2sin"
              width={600}
              title="Irish Platinum Location Map"
              height={450}
              frameBorder={0}
              style={{ border: 0 }}
              allowFullScreen
            />
          </div>
        </div>
        {/*-
        <div className="loc-detail">
          <div className="loc-div1">
            <div className="loc-text">
              <FaLocationDot className="icon-n" />
              <p className="text-lo"> 25 Mins. - Noida International Airport</p>
            </div>
            <div className="loc-text">
              <FaLocationDot className="icon-n" />
              <p className="text-lo"> 5 Mins. - Patanjali</p>
            </div>
            <div className="loc-text">
              <FaLocationDot className="icon-n" />
              <p className="text-lo"> 5 Mins. - Cricket Stadium</p>
            </div>
            <div className="loc-text">
              <FaLocationDot className="icon-n" />
              <p className="text-lo"> 15 Mins. - Vivo</p>
            </div>
            <div className="loc-text">
              <FaLocationDot className="icon-n" />
              <p className="text-lo"> 15 Mins. - Film City</p>
            </div>
            <div className="loc-text">
              <FaLocationDot className="icon-n" />
              <p className="text-lo"> 15 Mins. - Oppo</p>
            </div>
          </div>
        </div>
        -*/}
      </section>

      
      <section id='virtualsitetour' className='video-section-main'>
      <div className='video-head-div'>
      <h1 className="head">Virtual Site Visit</h1>
      </div>
      <div className="two-virtu">
<div  className='video-section'>

      <div className="video-container">
      <img className="tour-img" loading="lazy" src="i11.webp" alt="affordable-luxury-flats-noida-extension"/>
     
        <>
          <div className="overlay-text">
            <h1 className='over-text0'>APARTMENT VIEW</h1>
            <p>Irish Platinum - At Sector 10, Greater Noida West</p>
          </div>

          <button className="play-button"  aria-label="Play video" onClick={openEnquiryModal} ><FaRegCirclePlay className='logo-vi' /></button>
        </>
      
    </div>
    
    </div>
    <div  className='video-section'>

      <div className="video-container">
     <img className="tour-img" loading="lazy" src="i2.webp" alt="gated-community-noida-extension"/>
     
        <>
          <div className="overlay-text">
            <h1 className='over-text0'>VIRTUAL SITE VISIT</h1>
            <p>Irish Platinum - At Sector 10, Greater Noida West</p>
          </div>

          <button className="play-button"  aria-label="Play video" onClick={openEnquiryModal} ><FaRegCirclePlay className='logo-vi' /></button>
        </>
    
    </div>
    
    </div>
    </div>
    </section>
    
    
    </>
  );
};

export default Home;